import { matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AccountMatchParams,
  accountRouteProps,
} from 'src/navigation/routeProps'
import {
  selectCreditCardStatisticsActiveBudgetCountFromState,
  selectCreditCardStatisticsActiveVcnCountFromState,
  selectCreditCardStatisticsBudgetCountFromState,
  selectCreditCardStatisticsVcnCountFromState,
} from 'src/redux/selectors/data/creditCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

// `matchPath` returns `null` whenever the current background location is not an
// `/accounts/:id` URL, which happens for a render or two on every navigation
// AWAY from an account page — `AccountEntityPage` renders once against the new
// location before it unmounts. Returning `string | undefined` rather than
// asserting a match is what keeps that render from throwing; consumers that
// genuinely need an id gate on it.
export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountMatchParams>(
      backgroundLocation.pathname,
      accountRouteProps,
    )
    return mtch?.params.id
  },
)

export const selectCreditCardStatisticsActiveVcnCount = createSelector(
  [
    selectCreditCardStatisticsActiveVcnCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeVcnCount, creditCardId) => {
    return creditCardId !== undefined ? activeVcnCount[creditCardId] : undefined
  },
)

export const selectCreditCardStatisticsVcnCount = createSelector(
  [selectCreditCardStatisticsVcnCountFromState, selectCreditCardIdFromRoute],
  (vcnCount, creditCardId) => {
    return creditCardId !== undefined ? vcnCount[creditCardId] : undefined
  },
)

export const selectCreditCardStatisticsActiveBudgetCount = createSelector(
  [
    selectCreditCardStatisticsActiveBudgetCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeBudgetCount, creditCardId) => {
    return creditCardId !== undefined
      ? activeBudgetCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsBudgetCount = createSelector(
  [selectCreditCardStatisticsBudgetCountFromState, selectCreditCardIdFromRoute],
  (budgetCount, creditCardId) => {
    return creditCardId !== undefined ? budgetCount[creditCardId] : undefined
  },
)
